export type PaginationIntegerValue = number | string | null | undefined;

/** 将 WTM 可能返回的字符串分页字段收敛为安全整数。 */
export function normalizePaginationInteger(
  value: PaginationIntegerValue,
  fallback: number,
  minimum: number,
): number {
  const normalized =
    typeof value === "number"
      ? value
      : typeof value === "string" && value.trim()
        ? Number(value)
        : Number.NaN;
  return Number.isSafeInteger(normalized) && normalized >= minimum ? normalized : fallback;
}
